document.addEventListener("DOMContentLoaded", function() {
  const tapToFindBtn = document.getElementById("tapToFindBtn");
  const screens = document.querySelectorAll("[class^='screen']");
  const suggestedProduct = document.querySelector(".suggested-product");
  const lastQuestionIndex = screens.length - 1; // Index of the second last question

  // Define an array to store the selected answers
  let selectedAnswers = [];

  tapToFindBtn.addEventListener("click", function() {
    hideScreen(0); // Hide screen 1
    showScreen(1); // Show screen 2
  });

  const hideScreen = (index) => {
    screens[index].classList.add("hide-part");
  };

  const showScreen = (index) => {
    screens[index].classList.add("active-part");
    // Hide success div for the last question
    if (index === lastQuestionIndex) {
      const successDiv = screens[index].querySelector(".success");
      successDiv.classList.add("hide-part");
    }
  };

  const handleAnswerClick = (answerIndex, currentScreen) => {
    // Store the selected answer index
    selectedAnswers.push(answerIndex + 1); // Adding 1 to make it 1-indexed

    // Hide the spans inside answer divs and change fill color of <rect> for non-selected answers
    const answers = currentScreen.querySelectorAll(".answers div");
    answers.forEach((answer, index) => {
      const span = answer.querySelector("span");
      const rect = answer.querySelector("path");

      if (index !== answerIndex) {
        span.classList.add("hide-part");
        rect.setAttribute("fill", "#fff");
      }
    });

    // Log the selected answer
   // console.log("Selected Answers:", selectedAnswers);

    // If it's not the last question, proceed with showing success div
    if (currentScreen !== screens[lastQuestionIndex]) {
      // Wait for 3 seconds and then replace question and answers divs with success div
      setTimeout(() => {
        replaceWithSuccessDiv(currentScreen);
        // Move to the next question
        setTimeout(() => {
          replaceWithNextQuestion(currentScreen);
        }, 1000);
      }, 1000);
    } else {
      // If it's the last question, display suggested products
      setTimeout(() => {
        hideScreen(lastQuestionIndex);
        const combination = selectedAnswers.join('-');
        displaySuggestedProducts(combination); // Display suggested products based on selected answers
        console.log(combination);
        suggestedProduct.classList.add("active-part"); // Show suggested product div
      }, 2000);
    }
  };

  const replaceWithSuccessDiv = (currentScreen) => {
    const questionDiv = currentScreen.querySelector(".question");
    const answersDiv = currentScreen.querySelector(".answers");
    const successDiv = currentScreen.querySelector(".success");

    // Hide question and answers divs
    questionDiv.classList.add("hide-part");
    answersDiv.classList.add("hide-part");

    // Show success div
    successDiv.classList.add("active-part");
  };

  const replaceWithNextQuestion = (currentScreen) => {
    const currentIndex = Array.from(screens).indexOf(currentScreen);

    // Hide current question and answers
    hideScreen(currentIndex);

    // Show next question and answers
    const nextIndex = currentIndex + 1;
    showScreen(nextIndex);

    // Slide current screen from right to left
    animateSlider(nextIndex);
  };

  const animateSlider = (index) => {
    screens[index].style.animation = "slideInRight 0.5s forwards";
  };

  // Add event listeners to answer options
  screens.forEach((screen, index) => {
    const answerOptions = screen.querySelectorAll(".answers div");
    answerOptions.forEach((answerOption, answerIndex) => {
      answerOption.addEventListener("click", () => handleAnswerClick(answerIndex, screen));
    });
  });

// Function to display suggested products based on combination
const displaySuggestedProducts = (combination) => {
  const flavorMap = {
"1-1-1-1": "Indonesian-Cacao",
"1-1-1-2": "Ratnagiri-Mango-Vanilla-Latte",
"1-1-1-3": "Cocoa-Beet",
"1-1-2-1": "Vanilla-Latte",
"1-1-2-2": "Pina-Colada-Chikmagalur-Mocha",
"1-1-2-3": "Mint-Cacao",
"1-1-3-1": "Chikmagalur-Mocha",
"1-1-3-2": "Ratnagiri-Mango-Chikmagalur-Mocha",
"1-1-3-3": "Chikmagalur-Mocha",
"1-1-4-1": "Japanese-Matcha",
"1-1-4-2": "Pina-Colada-Japanese-Matcha",
"1-1-4-3": "Japanese-Matcha",
"1-1-5-1": "Kerala-Vanilla-Bean",
"1-1-5-2": "Ratnagiri-Mango",
"1-1-5-3": "Pina-Colada",
"1-2-1-1": "Kerala-Vanilla-Bean",
"1-2-1-2": "Ratnagiri-Mango-Kerala-Vanilla-Bean",
"1-2-1-3": "Vanilla-Latte",
"1-2-2-1": "Vanilla-Latte",
"1-2-2-2": "Ratnagiri-Mango",
"1-2-2-3": "Vanilla-Latte",
"1-2-3-1": "Chikmagalur-Mocha",
"1-2-3-2": "Ratnagiri-Mango",
"1-2-3-3": "Chikmagalur-Mocha",
"1-2-4-1": "Japanese-Matcha",
"1-2-4-2": "Ratnagiri-Mango",
"1-2-4-3": "Japanese-Matcha",
"1-2-5-1": "Kerala-Vanilla-Bean",
"1-2-5-2": "Ratnagiri-Mango",
"1-2-5-3": "Pina-Colada",
"1-3-1-1": "Mint-Cacao",
"1-3-1-2": "Ratnagiri-Mango",
"1-3-1-3": "Mint-Cacao",
"1-3-2-1": "Mint-Cacao",
"1-3-2-2": "Ratnagiri-Mango",
"1-3-2-3": "Mint-Cacao",
"1-3-3-1": "Chikmagalur-Mocha",
"1-3-3-2": "Ratnagiri-Mango",
"1-3-3-3": "Mint-Cacao",
"1-3-4-1": "Mint-Cacao",
"1-3-4-2": "Ratnagiri-Mango-Mint-Cacao",
"1-3-4-3": "Japanese-Matcha-Mint-Cacao",
"1-3-5-1": "Mint-Cacao",
"1-3-5-2": "Ratnagiri-Mango-Mint-Cacao",
"1-3-5-3": "Mint-Cacao",
"1-4-1-1": "Ratnagiri-Mango",
"1-4-1-2": "Pina-Colada-Ratnagiri-Mango",
"1-4-1-3": "Pina-Colada",
"1-4-2-1": "Ratnagiri-Mango-Vanilla-Latte",
"1-4-2-2": "Pina-Colada-Ratnagiri-Mango",
"1-4-2-3": "Pina-Colada",
"1-4-3-1": "Ratnagiri-Mango",
"1-4-3-2": "Pina-Colada-Ratnagiri-Mango",
"1-4-3-3": "Pina-Colada",
"1-4-4-1": "Pina-Colada",
"1-4-4-2": "Pina-Colada-Ratnagiri-Mango",
"1-4-4-3": "Pina-Colada-Japanese-Matcha",
"1-4-5-1": "Ratnagiri-Mango",
"1-4-5-2": "Pina-Colada-Ratnagiri-Mango",
"1-4-5-3": "Pina-Colada",
"2-1-1-1": "Indonesian-Cacao",
"2-1-1-2": "Kerala-Vanilla-Bean",
"2-1-1-3": "Vanilla-Latte",
"2-1-2-1": "Chikmagalur-Mocha",
"2-1-2-2": "Chikmagalur-Mocha-Ratnagiri-Mango",
"2-1-2-3": "Cocoa-Beet",
"2-1-3-1": "Chikmagalur-Mocha",
"2-1-3-2": "Chikmagalur-Mocha-Ratnagiri-Mango",
"2-1-3-3": "Chikmagalur-Mocha-Pina-Colada",
"2-1-4-1": "Japanese-Matcha",
"2-1-4-2": "Pina-Colada-Japanese-Matcha",
"2-1-4-3": "Japanese-Matcha",
"2-1-5-1": "Indonesian-Cacao",
"2-1-5-2": "Ratnagiri-Mango-Indonesian-Cacao",
"2-1-5-3": "Pina-Colada",
"2-2-1-1": "Kerala-Vanilla-Bean",
"2-2-1-2": "Ratnagiri-Mango-Kerala-Vanilla-Bean",
"2-2-1-3": "Vanilla-Latte",
"2-2-2-1": "Vanilla-Latte",
"2-2-2-2": "Ratnagiri-Mango-Vanilla-Latte",
"2-2-2-3": "Vanilla-Latte",
"2-2-3-1": "Vanilla-Latte",
"2-2-3-2": "Ratnagiri-Mango-Vanilla-Latte",
"2-2-3-3": "Chikmagalur-Mocha-Vanilla-Latte",
"2-2-4-1": "Japanese-Matcha",
"2-2-4-2": "Pina-Colada",
"2-2-4-3": "Japanese-Matcha",
"2-2-5-1": "Kerala-Vanilla-Bean",
"2-2-5-2": "Ratnagiri-Mango",
"2-2-5-3": "Pina-Colada",
"2-3-1-1": "Mint-Cacao",
"2-3-1-2": "Ratnagiri-Mango-Mint-Cacao",
"2-3-1-3": "Mint-Cacao",
"2-3-2-1": "Mint-Cacao-Vanilla-Latte",
"2-3-2-2": "Ratnagiri-Mango-Chikmagalur-Mocha",
"2-3-2-3": "Mint-Cacao",
"2-3-3-1": "Chikmagalur-Mocha",
"2-3-3-2": "Ratnagiri-Mango-Chikmagalur-Mocha",
"2-3-3-3": "Mint-Cacao",
"2-3-4-1": "Mint-Cacao",
"2-3-4-2": "Ratnagiri-Mango-Mint-Cacao",
"2-3-4-3": "Japanese-Matcha-Mint-Cacao",
"2-3-5-1": "Mint-Cacao",
"2-3-5-2": "Ratnagiri-Mango-Mint-Cacao",
"2-3-5-3": "Mint-Cacao",
"2-4-1-1": "Ratnagiri-Mango",
"2-4-1-2": "Pina-Colada-Ratnagiri-Mango",
"2-4-1-3": "Pina-Colada",
"2-4-2-1": "Ratnagiri-Mango-Vanilla-Latte",
"2-4-2-2": "Pina-Colada-Ratnagiri-Mango",
"2-4-2-3": "Pina-Colada",
"2-4-3-1": "Ratnagiri-Mango-Vanilla-Latte",
"2-4-3-2": "Pina-Colada-Ratnagiri-Mango",
"2-4-3-3": "Pina-Colada",
"2-4-4-1": "Pina-Colada",
"2-4-4-2": "Pina-Colada-Ratnagiri-Mango",
"2-4-4-3": "Pina-Colada-Japanese-Matcha",
"2-4-5-1": "Ratnagiri-Mango",
"2-4-5-2": "Pina-Colada-Ratnagiri-Mango",
"2-4-5-3": "Pina-Colada",
"3-1-1-1": "Indonesian-Cacao",
"3-1-1-2": "Ratnagiri-Mango-Kerala-Vanilla-Bean",
"3-1-1-3": "Vanilla-Latte",
"3-1-2-1": "Chikmagalur-Mocha",
"3-1-2-2": "Chikmagalur-Mocha-Ratnagiri-Mango",
"3-1-2-3": "Cocoa-Beet",
"3-1-3-1": "Chikmagalur-Mocha",
"3-1-3-2": "Chikmagalur-Mocha-Ratnagiri-Mango",
"3-1-3-3": "Chikmagalur-Mocha-Pina-Colada",
"3-1-4-1": "Japanese-Matcha",
"3-1-4-2": "Pina-Colada-Japanese-Matcha",
"3-1-4-3": "Japanese-Matcha",
"3-1-5-1": "Indonesian-Cacao",
"3-1-5-2": "Ratnagiri-Mango-Indonesian-Cacao",
"3-1-5-3": "Pina-Colada",
"3-2-1-1": "Kerala-Vanilla-Bean",
"3-2-1-2": "Ratnagiri-Mango-Kerala-Vanilla-Bean",
"3-2-1-3": "Vanilla-Latte",
"3-2-2-1": "Vanilla-Latte",
"3-2-2-2": "Ratnagiri-Mango-Vanilla-Latte",
"3-2-2-3": "Vanilla-Latte",
"3-2-3-1": "Vanilla-Latte",
"3-2-3-2": "Ratnagiri-Mango-Vanilla-Latte",
"3-2-3-3": "Chikmagalur-Mocha",
"3-2-4-1": "Japanese-Matcha",
"3-2-4-2": "Pina-Colada",
"3-2-4-3": "Japanese-Matcha",
"3-2-5-1": "Kerala-Vanilla-Bean",
"3-2-5-2": "Ratnagiri-Mango",
"3-2-5-3": "Pina-Colada",
"3-3-1-1": "Mint-Cacao-Kerala-Vanilla-Bean",
"3-3-1-2": "Ratnagiri-Mango-Mint-Cacao",
"3-3-1-3": "Mint-Cacao",
"3-3-2-1": "Mint-Cacao-Vanilla-Latte",
"3-3-2-2": "Ratnagiri-Mango-Chikmagalur-Mocha",
"3-3-2-3": "Mint-Cacao",
"3-3-3-1": "Chikmagalur-Mocha",
"3-3-3-2": "Ratnagiri-Mango-Chikmagalur-Mocha",
"3-3-3-3": "Mint-Cacao",
"3-3-4-1": "Mint-Cacao",
"3-3-4-2": "Ratnagiri-Mango-Mint-Cacao",
"3-3-4-3": "Japanese-Matcha-Mint-Cacao",
"3-3-5-1": "Mint-Cacao",
"3-3-5-2": "Ratnagiri-Mango-Mint-Cacao",
"3-3-5-3": "Mint-Cacao",
"3-4-1-1": "Ratnagiri-Mango",
"3-4-1-2": "Pina-Colada-Ratnagiri-Mango",
"3-4-1-3": "Pina-Colada",
"3-4-2-1": "Ratnagiri-Mango-Vanilla-Latte",
"3-4-2-2": "Pina-Colada-Ratnagiri-Mango",
"3-4-2-3": "Pina-Colada",
"3-4-3-1": "Ratnagiri-Mango-Vanilla-Latte",
"3-4-3-2": "Pina-Colada",
"3-4-3-3": "Pina-Colada",
"3-4-4-1": "Pina-Colada-Japanese-Matcha",
"3-4-4-2": "Pina-Colada-Ratnagiri-Mango",
"3-4-4-3": "Pina-Colada",
"3-4-5-1": "Ratnagiri-Mango",
"3-4-5-2": "Pina-Colada-Ratnagiri-Mango",
"3-4-5-3": "Pina-Colada",
"4-1-1-1": "Indonesian-Cacao",
"4-1-1-2": "Ratnagiri-Mango-Kerala-Vanilla-Bean",
"4-1-1-3": "Vanilla-Latte",
"4-1-2-1": "Chikmagalur-Mocha",
"4-1-2-2": "Chikmagalur-Mocha-Ratnagiri-Mango",
"4-1-2-3": "Cocoa-Beet",
"4-1-3-1": "Chikmagalur-Mocha",
"4-1-3-2": "Chikmagalur-Mocha-Ratnagiri-Mango",
"4-1-3-3": "Chikmagalur-Mocha",
"4-1-4-1": "Japanese-Matcha",
"4-1-4-2": "Pina-Colada-Japanese-Matcha",
"4-1-4-3": "Japanese-Matcha",
"4-1-5-1": "Indonesian-Cacao",
"4-1-5-2": "Ratnagiri-Mango-Indonesian-Cacao",
"4-1-5-3": "Pina-Colada",
"4-2-1-1": "Kerala-Vanilla-Bean",
"4-2-1-2": "Ratnagiri-Mango-Kerala-Vanilla-Bean",
"4-2-1-3": "Vanilla-Latte",
"4-2-2-1": "Vanilla-Latte",
"4-2-2-2": "Ratnagiri-Mango-Vanilla-Latte",
"4-2-2-3": "Vanilla-Latte",
"4-2-3-1": "Vanilla-Latte",
"4-2-3-2": "Ratnagiri-Mango-Vanilla-Latte",
"4-2-3-3": "Chikmagalur-Mocha",
"4-2-4-1": "Japanese-Matcha",
"4-2-4-2": "Pina-Colada",
"4-2-4-3": "Japanese-Matcha",
"4-2-5-1": "Kerala-Vanilla-Bean",
"4-2-5-2": "Ratnagiri-Mango",
"4-2-5-3": "Pina-Colada",
"4-3-1-1": "Mint-Cacao-Kerala-Vanilla-Bean",
"4-3-1-2": "Ratnagiri-Mango-Mint-Cacao",
"4-3-1-3": "Mint-Cacao",
"4-3-2-1": "Mint-Cacao-Vanilla-Latte",
"4-3-2-2": "Ratnagiri-Mango-Chikmagalur-Mocha",
"4-3-2-3": "Mint-Cacao",
"4-3-3-1": "Chikmagalur-Mocha",
"4-3-3-2": "Ratnagiri-Mango-Chikmagalur-Mocha",
"4-3-3-3": "Mint-Cacao",
"4-3-4-1": "Mint-Cacao",
"4-3-4-2": "Ratnagiri-Mango-Mint-Cacao",
"4-3-4-3": "Japanese-Matcha-Mint-Cacao",
"4-3-5-1": "Mint-Cacao",
"4-3-5-2": "Ratnagiri-Mango-Mint-Cacao",
"4-3-5-3": "Mint-Cacao",
"4-4-1-1": "Ratnagiri-Mango",
"4-4-1-2": "Pina-Colada-Ratnagiri-Mango",
"4-4-1-3": "Pina-Colada",
"4-4-2-1": "Ratnagiri-Mango-Vanilla-Latte",
"4-4-2-2": "Pina-Colada-Ratnagiri-Mango",
"4-4-2-3": "Pina-Colada",
"4-4-3-1": "Ratnagiri-Mango-Vanilla-Latte",
"4-4-3-2": "Pina-Colada",
"4-4-3-3": "Pina-Colada-Chikmagalur-Mocha",
"4-4-4-1": "Pina-Colada-Japanese-Matcha",
"4-4-4-2": "Pina-Colada-Ratnagiri-Mango",
"4-4-4-3": "Pina-Colada-Japanese-Matcha",
"4-4-5-1": "Ratnagiri-Mango",
"4-4-5-2": "Pina-Colada-Ratnagiri-Mango",
"4-4-5-3": "Pina-Colada"
  };

  const flavorClassName = flavorMap[combination];
  //console.log("Combination:", combination);
  //console.log("Flavor Class Name:", flavorClassName);

  const flavorDiv = document.querySelector(`.${flavorClassName}`);
  //console.log("Flavor Div:", flavorDiv);

  // Hide suggested product flavors initially
  Object.values(flavorMap).forEach((flavor) => {
    const flavorDiv = document.querySelector(`.${flavor}`);
    if (flavorDiv) {
      flavorDiv.classList.add("hide-part");
    }
  });

  const flavorsGif = document.querySelector(".flavours-gif");
  if (flavorsGif) {
    // Show the flavors-gif initially
    flavorsGif.classList.add("active-part");
    
    // After 2 seconds, hide the flavors-gif and display the product flavor
    setTimeout(() => {
      flavorsGif.classList.add("hide-part");
      if (flavorDiv) {
        flavorDiv.classList.add("active-part");
        flavorDiv.style.flexDirection = "column";
      }
    }, 2000);
  }
};


  
});

